import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'fdr-past-performance-ui-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'status',
    'aria-live': 'polite',
  },
  imports: [TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EmptyStateComponent {
  showPermissionStatus = input(false);
  title = input('PD.LABELS.NO_DATA_AVAILABLE');
  permissionText = input('PD.LABELS.CHECK_PERMISSION');
  subtitle = input<string | null>(null);
  icon = input<string | null>(null);
  emphasized = input(false);
}
